import { tv } from 'tailwind-variants';

export const logo = tv({
  base: ['block', 'w-full', 'max-w-full'],
});
